// (c) chaehongee. Confidential and proprietary.

import type { RootState } from '../store'
import { selectActiveSessionId } from './sessionSelectors'
import type { CanvasItem } from '../slices/canvasSlice'

const EMPTY_CANVAS_ITEMS: CanvasItem[] = []

export function selectCanvasItemsBySessionId(
    state: RootState,
    sessionId: string
): CanvasItem[] {
    return state.canvas.bySessionId[sessionId]?.items ?? EMPTY_CANVAS_ITEMS
}

export function selectActiveCanvasItems(state: RootState): CanvasItem[] {
    const id = selectActiveSessionId(state)
    return id ? selectCanvasItemsBySessionId(state, id) : EMPTY_CANVAS_ITEMS
}

